<template>

    <div class="w-full px-5">
        <div>
            <div
                class="flex flex-col md:flex-row rounded overflow-hidden border border-gray-30 md:divide-x divide-gray-30">
                <div
                    class="bg-gray-alabaster md:max-w-300 w-full md:w-4/12 md:min-h-570 h-full flex wall-builder-app__left">
                    <div class="w-full flex flex-col">
                        <div class="flex-shrink">
                            <div class="bg-gray-50 min-h-50">
                                <!-- Blank header -->
                            </div>
                        </div>
                        <div class="flex-auto">
                            <div class="flex flex-col h-full">
                                <div class="flex-auto">
                                    <div class="py-6 px-4 lg:px-6">
                                        <NFPA285Compliance v-show="currentStep == 0"
                                                           v-model="options.nfpa285Compliance.value"
                                                           @update:modelValue="goToNextStep"/>
                                        <BaseWall v-show="currentStep == 1" :nfpa="options.nfpa285Compliance.value"
                                                  v-model="options.baseWall.value" @update:modelValue="goToNextStep"/>
                                        <!-- Only display for basewall: steel-frame -->
                                        <CavityInsulation v-show="currentStep == 2" :baseWall="options.baseWall.value"
                                                          v-model="options.cavityInsulation.value"
                                                          @update:modelValue="goToNextStep"/>
                                        <Sheathing v-show="currentStep == 3" :baseWall="options.baseWall.value"
                                                   v-model="options.sheathing.value" @update:modelValue="goToNextStep"/>
                                        <InsideWrb v-show="currentStep == 4" v-model="options.insideWrb.value"
                                                   @update:modelValue="goToNextStep"/>
                                        <InsulationProduct v-show="currentStep == 5" :baseWall="options.baseWall.value"
                                                           :nfpa="options.nfpa285Compliance.value"
                                                           v-model="options.insulationProduct.value"
                                                           @update:modelValue="goToNextStep"/>
                                        <OutsideWrb v-show="currentStep == 6"
                                                    :insulation="options.insulationProduct.value"
                                                    v-model="options.outsideWrb.value"
                                                    @update:modelValue="goToNextStep"/>
                                        <Cladding v-show="currentStep == 7" :nfpa="options.nfpa285Compliance.value"
                                                  :insulation="options.insulationProduct.value"
                                                  :baseWall="options.baseWall.value"
                                                  :sheathing="options.sheathing.value"
                                                  v-model="options.cladding.value" @update:modelValue="goToNextStep"/>
                                        <MasonryCladdingType v-show="currentStep == 8"
                                                             :nfpa="options.nfpa285Compliance.value"
                                                             v-model="options.masonryCladdingType.value"
                                                             @update:modelValue="goToNextStep"/>
                                        <Summary ref="summary" v-show="currentStep == 9" :insulation="options.insulationProduct.value"
                                                 :nfpa="options.nfpa285Compliance.value"
                                                 :outside-wrb="options.outsideWrb.value"
                                                 :restart="restart" 
                                                 v-model:show-email-modal="showEmailModal"
                                                 v-model:email-address="emailAddress"
                                                 :email-error="emailError"
                                                 :email-success="emailSuccess"
                                                 @email="emailSummary" 
                                                 @send-email="sendEmail" 
                                                 :print="printSummary"/>
                                    </div>
                                </div>
                                <div class="flex-shrink" v-if="canGoToNextStep">
                                    <div class="flex items-center space-x-2 px-3 py-8 md:py-3.5">
                                        <div>
                                            <WizardButton theme="dark" :on-click="restart">Start Over</WizardButton>
                                        </div>
                                        <div>
                                            <WizardButton theme="red" :on-click="gotoPreviousStep"
                                                          v-show="currentStep > 0">Go Back
                                            </WizardButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-auto">
                    <div class="flex flex-col h-full">
                        <div class="flex-shrink wallBuilder-section__tabs">
                            <div class="flex bg-red-cardinal min-h-50">
                                <div class="flex w-full">
                                    <Tabs :currentStep="currentStep"/>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-auto">
                            <div ref="pdfContent" id="pdf-content"
                                 class="flex flex-col lg:flex-row space-y-10 lg:space-y-0 w-full px-6 py-8 forPrint">
                                <div class="flex-1 flex lg:order-2" id="visualization-capture">
                                    <Visualization :options="options"/>
                                </div>
                                <div class="w-4/12 flex-shrink flex items-start lg:order-1">
                                    <Selections :options="options"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WizardButton from "./components/WizardButton.vue";
import Tabs from "./components/Tabs.vue";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import NFPA285Compliance from "./steps/NFPA285Compliance.vue";
import BaseWall from "./steps/BaseWall.vue";
import CavityInsulation from "./steps/CavityInsulation.vue";
import Sheathing from "./steps/Sheathing.vue";
import InsideWrb from "./steps/InsideWrb.vue";
import InsulationProduct from "./steps/InsulationProduct.vue";
import OutsideWrb from "./steps/OutsideWrb.vue";
import Cladding from "./steps/Cladding.vue";
import MasonryCladdingType from "./steps/MasonryCladdingType.vue";
import axios from 'axios';
import Summary from "./steps/Summary.vue";

import Selections from "./components/Selections.vue";
import Visualization from "./components/Visualization.vue";

export default {
    components: {
        Visualization,
        Selections,
        WizardButton,
        Tabs,

        NFPA285Compliance,
        CavityInsulation,
        BaseWall,
        Sheathing,
        InsideWrb,
        InsulationProduct,
        OutsideWrb,
        Cladding,
        MasonryCladdingType,

        Summary
    },
    methods: {
        getCanvasOptions(overrides = {}) {
            return {
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                scale: 2,
                logging: false,
                onclone: (clonedDocument) => {
                    clonedDocument.querySelectorAll('img').forEach(img => {
                        img.loading = 'eager';
                        img.classList.remove('lazyload');
                        img.classList.remove('lazyload-fade');
                        img.style.opacity = '1';
                    });
                },
                ...overrides
            };
        },
        restart() {
            this.currentStep = 0;
            Object.keys(this.options).forEach(optionKey => {
                this.options[optionKey].value = null;
            })
        },

        async emailSummary() {
            this.showEmailModal = true;
            this.emailAddress = '';
            this.emailError = '';
            this.emailSuccess = '';
        },

        async sendEmail() {
            if (!this.emailAddress) {
                this.emailError = 'Please enter an email address';
                return;
            }

            try {
                // Create the wall visualization PDF
                const doc = new jsPDF();
                const element = document.getElementById('pdf-content');
                const headerElement = document.querySelector('.wallPdf-header');
                const footerElement = document.querySelector('.wallPdf-footer');

                // Wait for all images in the element to be loaded
                await Promise.all([
                    this.waitForImagesToLoad(element),
                    this.waitForImagesToLoad(headerElement),
                    this.waitForImagesToLoad(footerElement)
                ]);

                // Capture content, header, and footer
                const [canvas, headerCanvas, footerCanvas] = await Promise.all([
                    html2canvas(element, this.getCanvasOptions({
                        windowWidth: 2000,
                        windowHeight: 1800
                    })),
                    html2canvas(headerElement, this.getCanvasOptions({
                        windowWidth: 1000,
                        windowHeight: 600
                    })),
                    html2canvas(footerElement, this.getCanvasOptions({
                        windowWidth: 1200,
                        windowHeight: 800
                    })),
                ]);

                // Main content image (scaled)
                const imgData = canvas.toDataURL('image/png');
                const imgProps = doc.getImageProperties(imgData);
                const pdfWidth = doc.internal.pageSize.getWidth() - 20; // 10px margin each side
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                doc.addImage(imgData, 'PNG', 10, 40, pdfWidth, pdfHeight);

                // Header and footer images (scaled)
                const headerimgData = headerCanvas.toDataURL('image/png');
                const footerimgData = footerCanvas.toDataURL('image/png');
                doc.addImage(headerimgData, 'PNG', 10, 10, doc.internal.pageSize.width - 20, 12);
                doc.addImage(footerimgData, 'PNG', 10, doc.internal.pageSize.height - 30, doc.internal.pageSize.width - 20, 18);

                // Convert PDF to blob
                const pdfBlob = doc.output('blob');

                // Compress the PDF into a zip file
                const zip = new JSZip();
                zip.file('wall-visualization.pdf', pdfBlob);
                const zippedBlob = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 9 } });

                console.log('zipped');

                // Get the selected documents from the Summary component, enriched with names
                const summaryRef = this.$refs.summary;
                const selectedFilenames = summaryRef.selectedDocuments;
                const staticDocs = [
                    { file: 'EnergyShield_LEED_Certification_Flyer.pdf', name: 'Polyiso Insulation Benefits in LEED Certified Design' },
                    { file: 'AtlasWall_LimitedWarranty_202501-1.pdf', name: 'Atlas Wall-Limited Thermal Warranty' }
                ];
                const allDocItems = [...summaryRef.items, ...staticDocs];
                const selectedDocuments = selectedFilenames.map(file => {
                    const item = allDocItems.find(i => i.file === file);
                    return { file, name: item ? item.name : file };
                });

                // Create FormData object
                const formData = new FormData();
                formData.append('email', this.emailAddress);
                formData.append('wallVisualization', zippedBlob, 'wall-visualization.zip');
                formData.append('documents', JSON.stringify(selectedDocuments));

                // Send the request to the existing PHP endpoint with increased timeout
                const response = await axios.post('/actions/atlas-module/pdf-email/send-email', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    timeout: 30000, // 30 second timeout
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity
                });

                if (response.data.success) {
                    this.emailSuccess = 'Email sent successfully!';
                } else {
                    this.emailError = response.data.error || 'Failed to send email';
                }
            } catch (error) {
                console.error('Error sending email:', error);
                if (error.code === 'ECONNABORTED') {
                    this.emailError = 'Request timed out. Please try again.';
                } else if (error.response) {
                    this.emailError = error.response.data.error || 'Server error. Please try again.';
                } else if (error.request) {
                    this.emailError = 'No response from server. Please try again.';
                } else {
                    this.emailError = 'Failed to send email. Please try again.';
                }
            }
        },
        async waitForImagesToLoad(element) {
            if (!element) {
                return;
            }

            const images = element.querySelectorAll('img');
            await Promise.all(Array.from(images).map(img => {
                img.setAttribute('crossorigin', 'anonymous');

                if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
                return new Promise(resolve => {
                    const onDone = () => resolve();
                    img.addEventListener('load', onDone, { once: true });
                    img.addEventListener('error', onDone, { once: true });
                });
            }));
        },
        async printSummary() {
            const doc = new jsPDF();
            const element = document.getElementById('pdf-content');
            const headerElement = document.querySelector('.wallPdf-header');
            const footerElement = document.querySelector('.wallPdf-footer');

            // Wait for all images in the element to be loaded
            await Promise.all([
                this.waitForImagesToLoad(element),
                this.waitForImagesToLoad(headerElement),
                this.waitForImagesToLoad(footerElement)
            ]);

            // Capture content, header, and footer
            const [canvas, headerCanvas, footerCanvas] = await Promise.all([
                html2canvas(element, this.getCanvasOptions({
                    windowWidth: 2000,
                    windowHeight: 1800
                })),
                html2canvas(headerElement, this.getCanvasOptions({
                    windowWidth: 1000,
                    windowHeight: 600
                })),
                html2canvas(footerElement, this.getCanvasOptions({
                    windowWidth: 1200,
                    windowHeight: 800
                })),
            ]);

            // Main content image (scaled)
            const imgData = canvas.toDataURL('image/png');
            const imgProps = doc.getImageProperties(imgData);
            const pdfWidth = doc.internal.pageSize.getWidth() - 20; // 10px margin each side
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            doc.addImage(imgData, 'PNG', 10, 40, pdfWidth, pdfHeight);

            // Header and footer images (scaled)
            const headerimgData = headerCanvas.toDataURL('image/png');
            const footerimgData = footerCanvas.toDataURL('image/png');
            doc.addImage(headerimgData, 'PNG', 10, 10, doc.internal.pageSize.width - 20, 12);
            doc.addImage(footerimgData, 'PNG', 10, doc.internal.pageSize.height - 30, doc.internal.pageSize.width - 20, 18);

            // Output PDF in new window
            let base64string = doc.output('bloburi');
            let win = window.open();
            win.document.write('<iframe src="' + base64string + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        },    
        goToNextStep(updatedValue) {
            if (this.canGoToNextStep) {
                // Go to Inside WRB if masonry chosen
                if (this.currentStep === 1 && updatedValue === 'masonry') {
                    this.currentStep += 3;
                    return;
                }

                // Only go to step 4 if sheathing is not 'none'
                if (this.currentStep === 3 && updatedValue === 'none') {
                    this.currentStep += 2;
                    return;
                }
                // Go to OUtside WRB if energyshield-ply-pro is chosen
                if (this.currentStep === 5 && updatedValue === 'energyshield-ply-pro') {
                    this.currentStep += 1;
                    return;
                }
                // Outside WRB
                if (this.currentStep === 5 && !(this.options.sheathing.value === 'none' || this.options.insideWrb.value === 'none')) {
                    this.currentStep += 2;
                    return;
                }
                // Only go to step 8 if masonry is selected as the cladding
                if (this.currentStep === 7 && updatedValue !== 'masonry') {
                    this.currentStep += 2;
                    return;
                }

                this.currentStep++;
            }

        },
        gotoPreviousStep(updateValue) {
            if (this.canGoToPreviousStep) {
                // Only go to step 2 if steel-frame is selected
                if (this.currentStep === 3 && this.options.baseWall.value !== 'steel-frame') {
                    this.options[Object.keys(this.options)[this.currentStep]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-1]].value = null;
                    this.currentStep -= 2;
                    return;
                }

                if (this.currentStep === 4 && this.options.baseWall.value === 'masonry') {
                    this.options[Object.keys(this.options)[this.currentStep]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-1]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-2]].value = null;
                    this.currentStep -= 3;
                    return;
                }

                // Only go to step 4 if sheathing is not 'none'
                if (this.currentStep === 5 && this.options.sheathing.value === 'none') {
                    this.options[Object.keys(this.options)[this.currentStep]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-1]].value = null;
                    this.currentStep -= 2;
                    return;
                }

                // Only go to step 5 if sheathing is not 'none'  or insideWrb is not 'none' 1-30-25
                if (this.currentStep === 7 && !(this.options.sheathing.value === 'none' || this.options.insideWrb.value === 'none')) {
                    this.options[Object.keys(this.options)[this.currentStep]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-1]].value = null;
                    this.currentStep -= 2;
                    return;
                }

                // Only go to step 8 if masonry is selected as the cladding
                if (this.currentStep === 9 && this.options.cladding.value !== 'masonry') {
                    this.options[Object.keys(this.options)[this.currentStep]].value = null;
                    this.options[Object.keys(this.options)[this.currentStep-1]].value = null;
                    this.currentStep -= 2;
                    return;
                }

                this.options[Object.keys(this.options)[this.currentStep]].value = null;
                this.currentStep--;
            }
        }
    },
    computed: {
        canGoToPreviousStep: function () {
            return this.currentStep > 0;
        },
        canGoToNextStep: function () {
            return this.currentStep < Object.keys(this.options).length;
        }
    },
    data() {
        return {
            currentStep: 0,
            showEmailModal: false,
            emailAddress: '',
            emailError: '',
            emailSuccess: '',
            options: {
                nfpa285Compliance: {
                    label: 'NFPA 285 Compliance',
                    value: null
                },
                baseWall: {
                    label: 'Base Wall',
                    value: null
                },
                cavityInsulation: {
                    label: 'Batt Cavity Insulation',
                    value: null
                },
                sheathing: {
                    label: 'Sheathing',
                    value: null
                },
                insideWrb: {
                    label: 'Inside WRB',
                    value: null
                },
                insulationProduct: {
                    label: 'Insulation Product',
                    value: null
                },
                outsideWrb: {
                    label: 'Outside WRB',
                    value: null
                },
                cladding: {
                    label: 'Cladding',
                    value: null
                },
                masonryCladdingType: {
                    label: 'Masonry Cladding Type',
                    value: null
                }
            }
        }
    }
}
</script>

<style>
@media print {
    .entry-type-wallBuilder .header {
        display: none;
    }

    .entry-type-wallBuilder > .relative {
        display: none;
    }

    .entry-type-wallBuilder footer {
        display: none;
    }

    .wallBuilder-section {
        margin-top: 0;
    }

    .wallBuilder-section__title {
        display: none;
    }

    .wall-builder-app__left {
        display: none;
    }

    .wallBuilder-section__tabs {
        display: none;
    }

    #wall-builder-app {
        margin-top: 0;
    }

    .forPrint {
        flex-direction: row;
    }
}
</style>
